import axios from 'axios'
import apiUrl from '../constants'

export default {
  data() {
		return {
      // IRT Flow
      exceptionModal: false,
      exceptionAWB: "",
      exceptionTypeList: [],
      exceptionType: 2,
      exceptionErrorList: [],
      exceptionError: "",
      exceptionComment: "",
      exSuccModal: false,
      isSysExcp: false,
      exLoading: false,
      excErr: "",
      excTypErr: "",
      Trackingno: "",
      logMessage: ""
    }
  },

  methods: {
    // Get List of Exception Type
    getExceptionTypes() {
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getfetchExceptiontypemaster',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
      })
      .then(result => {
        
        if (result.data.ResultCode == 100) {

          this.exceptionTypeList = result.data.ResponseData.map(err => ({
            value: err.exceptiontypemasterid,
            text: err.exceptiontypename,
          }));
    
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => {
        console.error(error)
      });

      return this.exceptionTypeList;
    },

    // Get List of Exception Errors or Messages
    getExceptionErrors() {
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getExceptionValidationError',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
      })
      .then(result => {
        
        if (result.data.ResultCode == 100) {

          this.exceptionErrorList = result.data.ResponseData.map(err => ({
            value: err.ErrorCode,
            text: err.ValidationError,
          }));

        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => {
        console.error(error)
      });

      return this.exceptionErrorList;
    },

    // Raise System Defined or User Defined Exception
    raiseException() {

      if(!this.exceptionError.trim()) return this.excErr = "The Error / Exception Message field is required.";
      if(!this.exceptionType) return this.excTypErr = "The Exception Type field is required.";
      if (!this.exceptionComment && !this.exceptionError) return;

      this.excErr    = "";
      this.excTypErr = "";
      this.exLoading = true;

      // --- Endpoint selection ---
      let endpoint = this.isSysExcp ? 'upadteExceptionInIRT' : 'raiseExceptionforUser';

      this.input = ({
        createdBy: this.useremail || this.createdby,
        currentHubId: this.hubId || (Array.isArray(this.hubid) ? this.hubid[0] : this.hubid),
        exceptionTypeId: this.exceptionType
      });

      if(this.isSysExcp) this.input.ticketno = this.Trackingno;
      else this.input.errorMessage = this.exceptionError;

      if (this.exceptionAWB.trim()) this.input.shippingId = this.exceptionAWB.trim();
      if (this.exceptionComment.trim()) this.input.comment = this.exceptionComment.trim();

      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + endpoint,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {

          if (result.data.ResultCode == 100) {
            
            this.logMessage = result.data.ReturnMessage;

            this.resetIRTParams();
            this.exSuccModal = true;

            this.Trackingno = result.data.Trackingno || '';

            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.exLoading = false
        }, error => {
          this.exLoading = false
          this.$alertify.error('An error occurred while submitting the exception.');
          console.error(error)
        })
    },

    resetIRTParams() {
      this.exceptionAWB   = '';
      this.exceptionError = '';
      this.exceptionType  = 2;
      this.exceptionComment = '';

      this.isSysExcp      = false;
      this.exceptionModal = false;
      this.exSuccModal    = false;

      if(this.$refs.ship){
        this.$nextTick(() => {
          this.$refs.ship.focus();
        });
      }
    },

    // open exception modal to raise system defined exception
    openIRTExceptionModal(bsID, err, exno){
      this.exceptionAWB   = bsID.trim();
      this.exceptionError = err;
      this.Trackingno 	  = exno;
      this.isSysExcp      = true;
      this.exceptionModal = true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/IRTException.js